import Service from '../service/Service';
const service = new Service();
var countimg = 0;
var countpdf = 0;
var img_flag = false;
var pdf_flag = false;
var file_array = [];
var commentDocUrl = "[]";
var isReply = false;

export function filterLink(text) {
    var newstring = "";
    var mainstring = text;
    var matchedUrls = mainstring.match(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi);
    if (matchedUrls) {
        for (var j = 0; j < matchedUrls.length; j++) {
            if (matchedUrls[j].match("^www.firstcry.com") || matchedUrls[j].match("^parenting.firstcry.com")) {
                newstring = mainstring.replace(matchedUrls[j], '<a rel="noopener" target="_blank" href="//' + matchedUrls[j] + '" class="discDescrpLink">' + matchedUrls[j] + '</a>');
                mainstring = newstring;
            }
            else if (matchedUrls[j].match("www.firstcry.com") || matchedUrls[j].match("parenting.firstcry.com")) {
                newstring = mainstring.replace(matchedUrls[j], '<a rel="noopener" target="_blank" href="' + matchedUrls[j] + '" class="discDescrpLink">' + matchedUrls[j] + '</a>');
                mainstring = newstring;
            }
        }
        return mainstring;
    } else {
        return text;
    }
}

export function setWidth() {
    if (window.innerWidth < 767) {
        if (document.getElementsByClassName('write-comment')[0]) {
            document.getElementsByClassName('write-comment')[0].style.width = document.getElementsByClassName('main-container')[0].offsetWidth + "px";
        }
        if (document.getElementsByClassName('participate-popup')[0]) {
            document.getElementsByClassName('participate-popup')[0].style.width = document.getElementsByClassName('main-container')[0].offsetWidth + "px";
        }
        if (document.getElementsByClassName('comment-popup')[0]) {
            document.getElementsByClassName('comment-popup')[0].style.width = document.getElementsByClassName('main-container')[0].offsetWidth + "px";
        }
        if (document.getElementsByClassName('comment-popup')[0]) {
            document.getElementsByClassName('comment-popup')[0].style.width = document.getElementsByClassName('main-container')[0].offsetWidth + "px";
        }
    }
}


export function checkCheckbox(pt) {
    var ele;
    if (pt == 0) {
        ele = document.getElementsByClassName('participate-overlay')[0].getElementsByClassName('isAnonymous')[0];
    } else {
        ele = document.getElementsByClassName('comment-overlay')[0].getElementsByClassName('isAnonymous')[0];
    }
    if (ele.classList.contains('isChecked')) {
        ele.classList.remove('isChecked');
        ele.setAttribute('data-icon-font', 'z');
    } else {
        ele.classList.add('isChecked');
        ele.setAttribute('data-icon-font', 'A');
    }
}

export function shareOn(id) {
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    if(document.getElementById('share_' + id).getElementsByClassName('sharing-options') && document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0] && (document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0].style.display == 'none')){
        document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0].style.display = 'block';
    }else{
        document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0].style.display = 'none';
    }
    if (window.innerWidth < 767) {
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
        if(document.getElementsByClassName('sharing-options')[0]){
            document.getElementsByClassName('sharing-options')[0].style.display = 'block';
        }
    }
}

export function shareArticle(articleurl, shareoption, image, title) {
    var shareurl;
    if (!articleurl.includes('http')) {
        articleurl = 'https:' + articleurl;
    }
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    if (document.getElementsByClassName('share-overlay')[0]) {
        document.getElementsByClassName('share-overlay')[0].style.display = 'none';
    }
    if (shareoption == "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption == "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption == "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption == "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }
    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}

export function contestPopup(event){
    document.getElementsByClassName('sortBy_overlay')[0].style.display = 'block';
}

export function closeContestPopup(){
    document.getElementsByClassName('sortBy_overlay')[0].style.display = 'none';
}

export function loadcontestName(title) {
    var title = title;
    title = title.trim();
    title = title.toLowerCase();
    title = title.replace(/[^a-z0-9_\s-]/g, '<');
    title = title.replace(/[\s-]+/g, '-');
    title = title.replace(/[\s_]/g, '-');
    return title;
}

export function formatArticleDate(date) {
    let monthAry = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    let month = monthAry[new Date(date).getMonth()];
    let day = new Date(date).getDate() < 10 ? "0" + new Date(date).getDate() : new Date(date).getDate();
    let year = new Date(date).getFullYear();
    return day + " " + month + " " + year;
}

export function slideStage(e,eleRef, id) {
    console.log(id);
    if (navigator.onLine) {
        if (e.target.parentElement.classList.contains('next')) {
            document.querySelector(".parentUL_"+id).scrollLeft = (document.querySelector(".parentUL_"+id).scrollLeft + 210);
            eleRef.state.myactiveStage += 210;
            document.getElementsByClassName('prev_'+id)[0].style.display = 'block';
            document.getElementsByClassName('next_'+id)[0].style.display = 'none';
        } else {
            document.querySelector(".parentUL_"+id).scrollLeft = document.querySelector(".parentUL_"+id).scrollLeft - 210;
            eleRef.state.myactiveStage -= 210;
            document.getElementsByClassName('prev_'+id)[0].style.display = 'none';
            document.getElementsByClassName('next_'+id)[0].style.display = 'block';
        }
    } else {
        service.hideLoader();
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
}

export function networkCheck(){
    if(!navigator.onLine){
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
    if (global.ftk != '') {
        service.gardianProfileChk();
    }
}

export function goToFeature(contestType, contestID){
    if(navigator.onLine) {
        if(global.ftk != ''){
            if(contestType == "Milestone Contest") {
                window.location.href = "/memories/milestones?"+contestID;
            }
            else if(contestType == "Memories Contest"){
                window.location.href = "/memories/memoriesupload?"+contestID;
            }
            else if(contestType == "My Bumpie"){
                window.location.href = "/tools/my-baby-bump/?"+contestID;
            }
            else if(contestType == "Face a day"){
                window.location.href = "/tools/capture-baby-moments/?"+contestID;
            }
            else if(contestType == "Discussion" || contestType == "Read") {
                window.location.href = "/discussions";
            }
            else if(contestType == "Vaccination") {
                window.location.href = "/tools/child-vaccination-growth-tracker";
            }
            else if(contestType == "Baby Teething Tool") {
                window.location.href = "/tools/baby-teething";
            }
            else if(contestType == "Baby Names") {
                window.location.href = "/baby-names";
            }
            else if(contestType == "Write Blog") {
                window.location.href = "/write-for-us/create-post";
            }
            else if(contestType == "Groups") {
                window.location.href = "/groups";
            }
            else if(contestType == "Q and A") {
                window.location.href = "/qna/questions-answers";
            }
            service.gardianProfileChk();
        } else{
            service.showAlert("Please Login");
            window.location.href = global.loginUrl+'?URL='+ global.currentURL;            
        }
    }else{
        service.showAlert("Please Check Internet Connection!!!");
    }
}
